import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import DeleteConfirmModal from "components/common/DeleteConfirmModal";
import Button from "components/common/Button/Button";
import NewTag from "components/common/NewTag";

const CommonCewSeriesInput = (props) => {
  const {
    isAcessory,
    isColors,
    isRoofPitchs,
    isSizes,
    isStyles,
    isSubTypes,
    isUOM,
    isWorkTypes,
    isPricepweruom,
    setAddNewSeries,
    UOM = "",
    acessory = "",
    colors = "",
    roofPitchs = "",
    sizes = "",
    style = "",
    uomType = "",
    _id = null,
    workTypes = "",
    pricepweruom = "",
    addNewSeries,
    saveData,
    deleteData,
    category,
    manufacturer,
    categoryType,
    subTypes,
    allPrefered,
    priceData,
    setAllPrefered,
    materialSeriesData,
    setAllSeriesData,
    add,
    subType,
    roofPitch,
    editData = false,
    setAdd,
  } = props;

  const [accessory, setAccessory] = useState(acessory);
  const [uom, setUom] = useState(UOM);
  const [uomPrice, setPricePerUom] = useState(pricepweruom);
  const [workType, setWorkType] = useState(workTypes);
  const [color, setColor] = useState(colors);
  const [size, setSize] = useState(sizes);
  const [edit, setEdit] = useState(editData);
  const [isDelete, setIsDelete] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const deleteModal = () => (
    <DeleteConfirmModal
      isOpen={isDelete}
      toggle={() => setIsDelete(!isDelete)}
      onConfirm={() => {
        deleteData(_id);
        setIsDelete(false);
      }}
    />
  );

  const handleChange = (e, callback) => {
    callback(e.target.value);
  };

  const handleOnClickSave = () => {
    setIsSaving(true);
    saveData(
      { category, categoryType, subType, size, color, style, accessory, roofPitch, uomPrice, workType, uom, _id },
      {
        onSuccess: () => { setIsSaving(false); setEdit(false); setAdd(false); setAddNewSeries(false); },
        onError: () => setIsSaving(false),
      }
    );
  };

  const handleOnClickCancel = () => {
    if (addNewSeries) {
      setAdd(false);
      setAddNewSeries(false);
    }
    setEdit(false);
    setAccessory(acessory);
    setUom(UOM);
    setPricePerUom(pricepweruom);
    setWorkType(workTypes);
    setColor(colors);
    setSize(sizes);
  };
  const MultiRow = () => {
    if (
      (subType === "Aluminum" && categoryType === "Gutters") ||
      (subType === "Aluminum" && categoryType === "Leaders")
    ) {
      return true;
    } else {
      return false;
    }
  };
  const DisableSave = () => {
    if (category === "Shingle Roofing" || category === "Flat Roofing") {
      return !workType || !uomPrice;
    } else if (category === "Skylights" || category === "Roofing Accessories") {
      return !accessory || !uomPrice;
    } else if (category === "Capping" || category === "Fascia") {
      return !uomPrice;
    } else if (
      categoryType === "Gutters" ||
      category === "Leaders" ||
      category === "Screens"
    ) {
      return !size || !color || !uomPrice;
    } else return !color || !uomPrice;
  };

  return (
    <>
      {isDelete && deleteModal()}

      <Row style={{ marginBottom: "15px" }}>
        {((isAcessory && isAcessory !== "N/A") ||
          (acessory && acessory !== "N/A")) && (
          <Col md="2">
            <Form.Group style={{ position: "relative" }}>
              <NewTag createdAt={priceData?.createdAt} />
              <Form.Control
                name="pType"
                value={accessory}
                disabled={!edit}
                onChange={(event) => handleChange(event, setAccessory)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}
        {((isRoofPitchs && isRoofPitchs !== "N/A") ||
          (roofPitch && roofPitch !== "N/A")) && (
          <Col md="2">
            <Form.Group>
              <Form.Control
                name="pType"
                value={roofPitch}
                disabled
                // onChange={(event) => handleChange(event, setRoofPitch)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}
        {((isWorkTypes && isWorkTypes !== "N/A") ||
          (workTypes && workTypes !== "N/A")) && (
          <Col md="2">
            <Form.Group style={{ position: "relative" }}>
              {!((isAcessory && isAcessory !== "N/A") || (acessory && acessory !== "N/A")) && (
                <NewTag createdAt={priceData?.createdAt} />
              )}
              <Form.Control
                name="pType"
                value={workType}
                disabled={!edit}
                onChange={(event) => handleChange(event, setWorkType)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}
        {((isSubTypes && isSubTypes !== "N/A") ||
          (subType && subType !== "N/A")) && (
          <Col md="2">
            <Form.Group>
              <Form.Control
                name="pType"
                value={subType}
                disabled
                // onChange={(event) => handleChange(event, setSubType)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}
        {((isStyles && isStyles !== "N/A") || (style && style !== "N/A")) && (
          <Col md="2 ">
            <Form.Group>
              <Form.Control
                name="pType"
                value={style}
                disabled
                // onChange={(event) => handleChange(event, setStyle)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}

        {((isColors && isColors !== "N/A") || (colors && colors !== "N/A")) && (
          <Col md="1">
            <Form.Group>
              <Form.Control
                as="select"
                name="pType"
                value={color}
                disabled={!edit}
                onChange={(event) => handleChange(event, setColor)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              >
                <option value="">Choose...</option>
                <option value="White">White</option>
                <option value="Brown">Brown</option>
                <option value="Other">Other</option>
              </Form.Control>
            </Form.Group>
          </Col>
        )}

        {((isSizes && isSizes !== "N/A") || (sizes && sizes !== "N/A")) && (
          <Col md="1">
            <Form.Group>
              <Form.Control
                name="pType"
                value={size}
                disabled={!edit}
                onChange={(event) => handleChange(event, setSize)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
            </Form.Group>
          </Col>
        )}

        {((isUOM && isUOM !== "N/A") || (UOM && UOM !== "N/A")) && (
          <Col md="2">
            <Form.Group>
              {category === "Roofing Accessories" ? (
                <Form.Control
                  name="pType"
                  as="select"
                  value={uom}
                  disabled={!edit}
                  onChange={(event) => handleChange(event, setUom)}
                  style={{ textAlign: "center", fontSize: "0.8rem" }}
                >
                  <option value="">Choose...</option>
                  <option value="Foot">Foot</option>
                  <option value="Per">Per</option>
                </Form.Control>
              ) : (
                <Form.Control
                  name="pType"
                  value={uom}
                  disabled
                  onChange={(event) => handleChange(event, setUom)}
                  style={{ textAlign: "center", fontSize: "0.8rem" }}
                ></Form.Control>
              )}
            </Form.Group>
          </Col>
        )}

        {((isPricepweruom && isPricepweruom !== "N/A") ||
          (pricepweruom && pricepweruom !== "N/A")) && (
          <Col md="2">
            <Form.Group>
              <Form.Control
                type="number"
                value={uomPrice}
                disabled={!edit}
                onChange={(event) => handleChange(event, setPricePerUom)}
                style={{ textAlign: "center", fontSize: "0.8rem" }}
              ></Form.Control>
              {/* <Form.Group>
                <InputMask
                  className="inputmask"
                  mask="$9.00"
                  value={uomPriceData}
                  disabled={!edit}
                  onChange={(event) => handleChange(event, setPricePerUomData)}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: " 0.375rem 0.75rem",
                    fontSize: "1rem",
                    fontWeight: "400",
                    lineHeight: "1.5",
                    color: "#212529",
                    backgroundColor: "#fff",
                    backgroundClip: "padding-box",
                    border: "1px solid #ced4da",
                    appearance: "none",
                    borderRadius: "0.375rem",
                    transition:
                      "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
                  }}
                ></InputMask>
              </Form.Group> */}
            </Form.Group>
          </Col>
        )}

        {MultiRow() ? (
          (addNewSeries && !_id) ? (
            <Col md="2">
              <Row
              // style={
              //   MultiRow()
              //     ? {
              //         marginTop: "10px",
              //         display: "flex",
              //         justifyContent: "flex-end",
              //       }
              //     : {}
              // }
              >
                <Col md="6">
                  <Button
                    variant="success"
                    size="sm"
                    onClick={handleOnClickSave}
                    isLoading={isSaving}
                    disabled={DisableSave() || isSaving}
                  >
                    Save
                  </Button>
                </Col>
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleOnClickCancel}
                    disabled={isSaving}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col md="2">
              <Row>
                <Col md="6">
                  {!edit ? (
                    <Button
                      variant="primary"
                      size="sm"
                      textSize="sm"
                      style={{ width: "60px" }}
                      onClick={() => setEdit(!edit)}
                    >
                      Edit
                    </Button>
                  ) : (
                    <Button
                      variant="success"
                      size="sm"
                      textSize="sm"
                      style={{ width: "60px" }}
                      onClick={handleOnClickSave}
                      isLoading={isSaving}
                      disabled={DisableSave() || isSaving}
                    >
                      Save
                    </Button>
                  )}
                </Col>
                {!edit && (
                  <Col md="6">
                    <Button
                      variant="danger"
                      size="sm"
                      textSize="sm"
                      onClick={() => setIsDelete(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                )}

                {edit && (
                  <Col md="1">
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={handleOnClickCancel}
                    >
                      Cancel
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>
          )
        ) : (addNewSeries && !_id) ? (
          <Col md="2">
            <Row>
              <Col md="6">
                <Button
                  variant="success"
                  size="sm"
                  textSize="sm"
                  style={{ width: "60px" }}
                  onClick={handleOnClickSave}
                  isLoading={isSaving}
                  disabled={DisableSave() || isSaving}
                >
                  Save
                </Button>
              </Col>
              <Col md="6">
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleOnClickCancel}
                  disabled={isSaving}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Col>
        ) : (
          <Col md="2">
            <Row>
              <Col md="6">
                {!edit ? (
                  <Button
                    variant="primary"
                    size="sm"
                    textSize="sm"
                    style={{ width: "60px" }}
                    onClick={() => setEdit(!edit)}
                  >
                    Edit
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    size="sm"
                    textSize="sm"
                    style={{ width: "60px" }}
                    onClick={handleOnClickSave}
                    isLoading={isSaving}
                    disabled={DisableSave() || isSaving}
                  >
                    Save
                  </Button>
                )}
              </Col>
              {!edit && (
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    textSize="sm"
                    onClick={() => setIsDelete(true)}
                  >
                    Delete
                  </Button>
                </Col>
              )}

              {edit && (
                <Col md="6">
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleOnClickCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
};

export default CommonCewSeriesInput;
